import { businessFields, type BusinessValues } from './types.ts';

export function businessFieldErrors(values: Record<string, unknown>): Partial<Record<keyof BusinessValues, string>> {
  const errors: Partial<Record<keyof BusinessValues, string>> = {};
  for (const [key, label] of businessFields) {
    const value = values[key];
    if (typeof value !== 'string' || value.length > 500 || [...value].some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) {
      errors[key] = `${label}: use one line of text, up to 500 characters.`;
    }
  }
  if (!errors.company_name && !String(values.company_name).trim()) errors.company_name = 'Enter the company name.';
  if (!errors.address && !String(values.address).trim()) errors.address = 'Enter the shipping address.';
  if (!errors.country && !/^[A-Z]{2}$/i.test(String(values.country).trim())) errors.country = 'Enter a two-letter country code, such as MT, US or GB.';
  if (!errors.currency && !/^[A-Z]{3}$/i.test(String(values.currency).trim())) errors.currency = 'Enter a three-letter currency code, such as EUR, USD or GBP.';
  return errors;
}
